import { FC } from 'react';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';
import { Loading } from '../../../../lib/components';

import { Group } from '@pxtra-client-lib-legacy/gen';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../lib/components/atomic/button';
interface Props {
  data: Group[];
  onAddButtonClicked: () => void;
}

export const GroupDataView: FC<Props> = ({ data, onAddButtonClicked }) => {
  const { t } = useTranslation();

  return data ? (
    data.length > 0 ? (
      <DataGrid>
        {data?.map((group) => (
          <DataGridElement title={t('company:GROUP')} value={group.name} key={group.id} xs={6} />
        ))}
      </DataGrid>
    ) : (
      <Box display="grid">
        <Typography sx={{ paddingBottom: 6, paddingTop: 3 }} align="center">
          {t('template:EMPTY_TABLE')}
        </Typography>
        <Button onClick={onAddButtonClicked} className="m-auto">
          {t('template:ADD')}
        </Button>
      </Box>
    )
  ) : (
    <Loading />
  );
};
